export class UpdateAgentTenantDescPayload{

    public   AgentID       ?:string;
    public   AgentDesc     ?:string;
    public   TenantID      ?:string;
    public   TenantDesc    ?:string;
    public   agentSession  ?:string;
}